export var DatePickerRepeat;
(function (DatePickerRepeat) {
    DatePickerRepeat["EVERY_TODAY"] = "every-today";
    DatePickerRepeat["EVERY_YESTERDAY"] = "every-yesterday";
})(DatePickerRepeat || (DatePickerRepeat = {}));
export var TimePickerRepeat;
(function (TimePickerRepeat) {
    TimePickerRepeat["FROM"] = "from";
    TimePickerRepeat["TO"] = "to";
    TimePickerRepeat["AT"] = "at";
})(TimePickerRepeat || (TimePickerRepeat = {}));
